/** Type for product parameter information */

type TParameters = Record<string, {
    TargetType?: string;
    Path?: string;
    [property: string]: any;
}>;

export default TParameters;
